import apiClient from "../apiClient";

const resource = "Assignments";

export default {
    getAll: params => apiClient.get(`${resource}?${params}`),
    getDetails: id => apiClient.get(`${resource}/${id}/details`),
    getForEdit: id => apiClient.get(`${resource}/${id}`),
    add: payload => apiClient.post(`${resource}`, payload,{ 'Content-Type': 'multipart/form-data' }),

    edit: (id, payload) => apiClient.put(`${resource}/${id}`, payload,{ 'Content-Type': 'multipart/form-data' }),
    lock: id => apiClient.put(`${resource}/${id}/lock`),
    unlock: id => apiClient.put(`${resource}/${id}/unlock`),
    delete: id => apiClient.delete(`${resource}/${id}`),
};
